import { Button, Modal, Alert } from "react-bootstrap";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import { BsX } from "../../../../icons/bs";
import { AgGridReact } from "ag-grid-react";
import { useRef, useState, useEffect } from "react";
import { getWCSDataHeader } from "../../../../Services/wcs-services";
import GolbalSearch from "../../common/helpers/GolbalSearch";
import GridLoader from "react-spinners/GridLoader";
import { getAllTraining } from "../../../../Services/training-service";
import { formatDateDD_MM_YYYY } from "../../../../functions/welding-functions";
import { getGridHeaderData } from "../../../../Services/wpq_groove-services";
import { getWiWeldingNumbersProjJointProcessWise, getWpqNpcilLinkByProjectNumber } from "../../../../Services/WI-services";
import { getPEDUsers } from "../../../../Services/user-service";

const MultiValuePopUp = (props) => {
  const [hasPreSelected, setHasPreSelected] = useState(false);
  let arr = props.masterName.split(":");
  let masterName = arr[0];
  const gridRef = useRef();
  const [columnDefs, setColumnDefs] = useState([]);
  const [rowData, setRowData] = useState(null);
  const [ready, setReady] = useState(false);
  const [filteredCol, setFilteredCol] = useState([]);
  const [filteredResult, setFilteredResult] = useState([]);
  const selectedCard = [];
  const [alertMessage, setAlertMessage] = useState("");
  const [gridApi, setGridApi] = useState(null);
  const year = new Date().getFullYear()
  const selectedYear = year;
  const [selectedData, setSelectedData] = useState(props.selectedData || []);
  const [loading, setLoading] = useState(true);

  const fetchTraining = async () => {
    try {
      setLoading(true);
      const upcoming = await getAllTraining("Upcoming");
      const inProgress = await getAllTraining("InProgress");
      const now = new Date();
      const currentDate = now.toISOString().split('T')[0];
      const currentTime = now.getHours() * 60 + now.getMinutes();

      const filteredInProgress = inProgress.filter(item => {
        if (item.wld_fromDate === currentDate) {
          const [hours, minutes] = item.wld_startTime.split(':').map(Number);
          const startTimeMinutes = hours * 60 + minutes;
          return (startTimeMinutes - currentTime) > 60;
        }
        return true;
      });

      const mergedResult = [...upcoming, ...filteredInProgress];

      setRowData(mergedResult);
      setFilteredResult(mergedResult);
      setLoading(false);

      return mergedResult;
    } catch (error) {
      console.error("Error fetching training:", error);
      setLoading(false);
    }
  };

  let joint = props?.action ? props?.wiobj?.WI_Joint_Type : props?.JointType;
  let welderid = props?.action ? props?.wiobj?.WIWelderid : props?.WIWelderid;

  const fetchwpq = async () => {
    let consolidatedResult = [];
    const currentYear = new Date().getFullYear();
    const BATCH_SIZE = 2000;

    setLoading(true);

    try {
      for (let year = 2025; year <= currentYear; year++) {
        console.log(`📦 Fetching WPQ data for year: ${year}`);

        const result = await getGridHeaderData(
          joint,
          sessionStorage.getItem("Band"),
          sessionStorage.getItem("User"),
          year
        );

        if (result && result.length > 0) {
          console.log(`📊 Year ${year} - Total records: ${result.length}`);
          const yearApproved = result.filter(item => item.WPSH_Status === "Approved");
          console.log(`📊 Year ${year} - Approved records: ${yearApproved.length}`);

          for (let i = 0; i < result.length; i += BATCH_SIZE) {
            const chunk = result.slice(i, i + BATCH_SIZE);
            consolidatedResult = [...consolidatedResult, ...chunk];

            if (i + BATCH_SIZE < result.length) {
              await new Promise(resolve => setTimeout(resolve, 100));
            }
          }
          console.log(`✅ Year ${year} loaded: ${result.length} records`);
        }
      }

      const approvedRecords = consolidatedResult.filter((item) => item.WPSH_Status === "Approved");

      console.log(`🎉 Total WPQ records loaded: ${consolidatedResult.length}`);
      console.log(`✅ Approved WPQ records: ${approvedRecords.length}`);
      console.log(`❌ Non-approved records filtered out: ${consolidatedResult.length - approvedRecords.length}`);

      if (approvedRecords.length > 0) {
        setRowData(approvedRecords);
        setFilteredResult(approvedRecords);
      }

    } catch (error) {
      console.error("Error fetching WPQ data:", error);
    } finally {
      setLoading(false);
    }
  }

  const fetchWCSJoints = async () => {
    if (props.masterName === "NPCILGrid" || props.masterName === "WPQJointNoGrid") {
      setRowData(props.paramvalue);
      setFilteredResult(props.paramvalue)
    }
    else {
      let projectNumber = props.paramvalue.projectNumber;
      let action = props.paramvalue.action;
      let selectedJointNos = await getWCSDataHeader({ WCS_Project_No: projectNumber });
      if (action === "Add" && selectedJointNos?.length > 1) {
        let dataObj = { "projectNumber": projectNumber };
        const npcilAllProjects = await getWpqNpcilLinkByProjectNumber(dataObj);
        let includedJointNos = [];
        let nonIncludedJointNos = [];
        for (const element of selectedJointNos[1]) {
          const jointNo = element.WCS_Joint_No;
          npcilAllProjects?.some(item => {
            const jointNos = item.WI_Joint_No.split(",");
            if (jointNos.includes(jointNo)) {
              includedJointNos.push(jointNo);
              return true;
            }
          });
          if (!includedJointNos.includes(jointNo)) {
            nonIncludedJointNos.push(element);
          }
        }
        setRowData(nonIncludedJointNos);
        setFilteredResult(nonIncludedJointNos);
      }
      else if (selectedJointNos?.length > 1) {
        if (selectedJointNos[1].length > 0) {
          setRowData(selectedJointNos[1]);
          setFilteredResult(selectedJointNos[1]);
        }
      }
    }
    setLoading(false)
  }

  const fetchWIgrid = async () => {
    // When linked WPQ data is already fetched and passed via props (hyperlink click),
    // display it directly without re-querying DB with year/status filters
    if (welderid?.length > 0) {
      setRowData(welderid);
      setFilteredResult(welderid);
      setLoading(false);
      return;
    }
    let result = []
    result = await getGridHeaderData(
      joint,
      sessionStorage.getItem("Band"),
      sessionStorage.getItem("User"),
      selectedYear
    );

    const approved = result.filter((item) => item.WPSH_Status === "Approved")
    const welderIds = welderid.map(item => item.SK);
    const filteredByWelderIdAndRecordNo = approved.filter((item) => welderIds.includes(item.SK));
    setRowData(filteredByWelderIdAndRecordNo);
    setFilteredResult(filteredByWelderIdAndRecordNo);
    setLoading(false)
  }

  const fetchWIProjectJointProcessWise = async () => {
    const result = await getWiWeldingNumbersProjJointProcessWise(props.paramvalue.projectNumber, props.paramvalue.jointNumber, props.paramvalue.weldingProcess);

    // Filter out duplicate entries based on WI_Welder_Id and WI_Welder_Name
    const uniqueData = [];
    for (let i of result) {
      let isDuplicate = uniqueData.some(x => x.WI_Project_No === i.WI_Project_No && x.WI_Joint_No === i.WI_Joint_No && x.WI_Process === i.WI_Process && x.WI_Welder_Id === i.WI_Welder_Id);
      if (!isDuplicate) {
        uniqueData.push(i);
      }
    }
    // Set the filtered data
    setRowData(uniqueData);
    setFilteredResult(uniqueData);
    setLoading(false)
    return uniqueData;
  };

  const fetchWelderData = async () => {
    if (props.welderData) {
      setRowData(props.welderData);
      setFilteredResult(props.welderData);
    }
    setLoading(false);
  };

  const fetchPEDUserData = async () => {
    // Add your PED User data fetching logic here    
    const result = await getPEDUsers();
    // For now, using empty array as placeholder
    const pedUserData = result;
    setRowData(pedUserData);
    setFilteredResult(pedUserData);
    setLoading(false);
  };

  const defaultColDef = {
    resizable: true,
    suppressMovable: true,
    filter: true,
    sortable: true,
    filterParams: {
      buttons: ["reset", "apply"],
      closeOnApply: true,
      defaultJoinOperator: "OR",
    },
  };

  const resetData = () => {
    gridRef?.current?.api?.forEachNode((node) => {
      node.setSelected(false);
    });
  }

  const onRowSelected = (event) => {
    let Index;
    const filteredNodes = [];
    // Get filtered nodes
    event.api.forEachNodeAfterFilter(node => {
      filteredNodes.push(node);
    });
    // Check if the selected node is part of the filtered nodes
    const isFilteredNode = filteredNodes.some(node => node === event.node);
    if (!isFilteredNode) {
      return; // Exit if the node is not part of the filtered nodes
    }
    switch (masterName) {
      case "WPQ":
        Index = selectedData.findIndex((element) => element.SK === event.node.data.SK);
        if (event.node.isSelected()) {
          if (Index === -1) {
            setSelectedData((data) => [...data, event.node.data]);
          }
        }
        else if (Index !== -1) {
          selectedData.splice(Index, 1);
          setSelectedData([...selectedData]);
        }
        break;
      case "NPCIL":
        Index = selectedData.findIndex((element) => element.WCS_Joint_No === event.node.data.WCS_Joint_No);
        if (event.node.isSelected()) {
          if (Index === -1) {
            setSelectedData((data) => [...data, event.node.data]);
          }
        }
        else if (Index !== -1) {
          selectedData.splice(Index, 1);
          setSelectedData([...selectedData]);
        }
        break;
      case "Welder":
        Index = selectedData.findIndex((element) => element.SK === event.node.data.SK);
        if (event.node.isSelected()) {
          if (Index === -1) {
            setSelectedData((data) => [...data, event.node.data]);
          }
        }
        else if (Index !== -1) {
          selectedData.splice(Index, 1);
          setSelectedData([...selectedData]);
        }
        break;
      case "PED User":
        Index = selectedData.findIndex((element) => element.empSalCode === event.node.data.empSalCode);
        if (event.node.isSelected()) {
          if (Index === -1) {
            setSelectedData((data) => [...data, event.node.data]);
          }
        }
        else if (Index !== -1) {
          selectedData.splice(Index, 1);
          setSelectedData([...selectedData]);
        }
        break;
      case "Training Subject and Date":
        Index = selectedData.findIndex((element) => element.SK === event.node.data.SK);
        if (event.node.isSelected()) {
          if (Index === -1) {
            setSelectedData((data) => [...data, event.node.data]);
          }
        }
        else if (Index !== -1) {
          selectedData.splice(Index, 1);
          setSelectedData([...selectedData]);
        }
        break;
    }
  };

  const onGridReady = (params) => {
    setReady(!ready);
    gridRef.current.api.sizeColumnsToFit();
    setGridApi(params.api)
  };

  useEffect(() => {
    if (selectedData.length > 0 && !hasPreSelected && gridRef?.current?.api) {
      const keyField = getKeyField();
      if (keyField) {
        const selectedSet = new Set(selectedData.map(item => item[keyField]?.toString()));
        gridRef.current.api.forEachNode((node) => {
          if (selectedSet.has(node?.data[keyField]?.toString())) {
            node.setSelected(true);
          }
        });
        setHasPreSelected(true);
      }
    }
  }, [filteredResult, selectedData, hasPreSelected, masterName]);

  useEffect(() => {
    switch (masterName) {
      case "Training Subject and Date":
        fetchTraining()
        setColumnDefs([
          {
            width: 60,
            checkboxSelection: true,
            scrollX: true
          },
          {
            field: "wld_trainingSub",
            headerName: "Training Subject",
            tooltipField: "wld_trainingSub",
          },
          {
            field: "wld_fromDate",
            headerName: "From",
            tooltipField: "wld_fromDate",
            valueFormatter: (params) => { return (formatDateDD_MM_YYYY(params.data.wld_fromDate)) }
          },
          {
            field: "wld_toDate",
            headerName: "To",
            tooltipField: "wld_toDate",
            valueFormatter: (params) => { return (formatDateDD_MM_YYYY(params.data.wld_toDate)) }
          },
          {
            field: "wld_faculty",
            headerName: "Faculty",
            tooltipField: "wld_faculty",
          }
        ]);
        break;
      case "WPQ":
        fetchwpq();
        //Call fetch wpq linking 
        setColumnDefs([
          {
            width: 60,
            checkboxSelection: true,
            headerCheckboxSelection: true,
            scrollX: true
          },
          {
            width: 150,
            field: "WPQ_WelderId",
            headerName: "Welder ID",
            tooltipField: "WPQ_WelderId"
          },
          {
            width: 150,
            field: "WPQ_WelderName",
            headerName: "Welder Name",
            tooltipField: "WPQ_WelderName",
          },
          {
            width: 150,
            field: "WPQ_RecordNo",
            headerName: "WPQ No",
            tooltipField: "WPQ_RecordNo",
          },
          {
            field: "wld_WPSType",
            headerName: "Joint Type",
            tooltipField: "wld_WPSType",
          },
          {
            width: 150,
            field: "WPQ_Inspection",
            headerName: "Inspection agency",
            tooltipField: "WPQ_Inspection",
          },
          {
            width: 150,
            field: "WPQ_Qualificationcode",
            headerName: "Qualification Code",
            tooltipField: "WPQ_Qualificationcode",
          },
          {
            width: 150,
            field: "WPQ_PlantLocation",
            headerName: " Plant Location",
            tooltipField: "WPQ_PlantLocation",
          },
          {
            width: 150,
            field: "WPQ_specialNote",
            headerName: " Special Notes",
            tooltipField: "WPQ_specialNote",
          }
        ]);
        break;
      case "NPCIL":
        fetchWCSJoints();
        setColumnDefs([
          {
            width: 60,
            checkboxSelection: true,
            headerCheckboxSelection: true,
            scrollX: true
          },
          {
            width: 820,
            field: "WCS_Joint_No",
            headerName: "Joint Number",
            tooltipField: "Joint Number"
          }
        ]);
        break;
      case "WPQJointNoGrid":
        fetchWCSJoints();
        setColumnDefs([
          {
            width: 850,
            field: "WCS_Joint_No",
            headerName: "Joint Number",
            tooltipField: "Joint Number"
          }
        ]);
        break;
      case "NPCILGrid":
        fetchWCSJoints();
        setColumnDefs([
          {
            width: 850,
            field: "WCS_Joint_No",
            headerName: "Joint Number",
            tooltipField: "Joint Number"
          }
        ]);
        break;
      case "WPQLinkGrid":
        fetchWIgrid();
        setColumnDefs([
          {
            width: 150,
            field: "WPQ_WelderId",
            headerName: "Welder ID",
            tooltipField: "WPQ_WelderId"
          },
          {
            width: 150,
            field: "WPQ_WelderName",
            headerName: "Welder Name",
            tooltipField: "WPQ_WelderName",
          },
          {
            width: 150,
            field: "WPQ_RecordNo",
            headerName: "WPQ No",
            tooltipField: "WPQ_RecordNo",
          },
          {
            field: "wld_WPSType",
            headerName: "Joint Type",
            tooltipField: "wld_WPSType",
          },
          {
            width: 150,
            field: "WPQ_Inspection",
            headerName: "Inspection agency",
            tooltipField: "WPQ_Inspection",
          },
          {
            width: 150,
            field: "WPQ_Qualificationcode",
            headerName: "Qualification Code",
            tooltipField: "WPQ_Qualificationcode",
          },
          {
            width: 150,
            field: "WPQ_PlantLocation",
            headerName: " Plant Location",
            tooltipField: "WPQ_PlantLocation",
          },
          {
            width: 150,
            field: "WPQ_specialNote",
            headerName: " Special Notes",
            tooltipField: "WPQ_specialNote",
          }
        ]);
        break;
      case "Welding Repair- WI Welding Numbers":
        fetchWIProjectJointProcessWise()
        setColumnDefs([
          {
            width: 60,
            checkboxSelection: true,
            scrollX: true
          },
          {
            field: "WI_Project_No",
            headerName: "Project Number",
            tooltipField: "WI_Project_No"
          },
          {
            field: "WI_Joint_No",
            headerName: "Joint Number",
            tooltipField: "WI_Joint_No"
          },
          {
            field: "WI_Process",
            headerName: "Process Number",
            tooltipField: "WI_Process"
          },
          {
            field: "WI_Welder_Id",
            headerName: "Welder Id",
            tooltipField: "WI_Welder_Id"
          },
          {
            field: "WI_Welder_Name",
            headerName: "Welder Name",
            tooltipField: "WI_Welder_Name"
          }
        ]);
        break;
      case "Welder":
        fetchWelderData();
        setColumnDefs([
          {
            width: 60,
            checkboxSelection: true,
            headerCheckboxSelection: true,
            scrollX: true
          },
          {
            width: 250,
            field: "SK",
            headerName: "Welder ID",
            tooltipField: "SK"
          },
          {
            width: 500,
            field: "wld_name",
            headerName: "Welder Name",
            tooltipField: "wld_name"
          }
        ]);
        break;
      case "PED User":
        fetchPEDUserData();
        setColumnDefs([
          {
            width: 60,
            checkboxSelection: true,
            headerCheckboxSelection: true,
            scrollX: true
          },
          {
            field: "empSalCode",
            headerName: "Employee Code",
            tooltipField: "empSalCode",
          },
          {
            field: "empEmailId",
            headerName: "Email ID",
            tooltipField: "empEmailId",
          },
          {
            field: "empshortName",
            headerName: "Employee Name",
            tooltipField: "empShortName",
          },
          {
            field: "empL1",
            headerName: "Employee L1",
            tooltipField: "EmpL1",
          },
          {
            field: "empBand",
            headerName: "Employee Band",
            tooltipField: "EmpBand",
          },
        ]);
        break;
    }
  }, []);

  const assignDataByType = (type = 'default') => {
    let selectedRows;
    switch (type) {
      case 'wpq':
        selectedRows = selectedData;
        break;
      case 'custom':
        selectedRows = selectedCard;
        break;
      default:
        selectedRows = selectedData.length > 0 ? selectedData : gridRef.current.api.getSelectedRows();
    }

    if (selectedRows.length > 0) {
      props.setSelected({ name: props.masterName, result: selectedRows });
      props.onHide();
    } else {
      setAlertMessage(type === 'wpq' ? "Please select record before clicking on Add button." : "Please select record before clicking on Assign button.");
    }
  };

  const applyDefaultSelection = () => {
    if (gridApi !== null && (props.masterName === "WPQLinkGrid" || props.masterName === "WPQ" || props.masterName === "Welder" || props.masterName === "PED User" || props.masterName === "Training Subject and Date") && (props.paramkey === "WI_Welder_Id" || props.paramkey === "emailid" || props.paramkey === "Training Subject" || props.paramkey === "SK")) {
      const selectedWelderSet = new Set(
        (props?.filteredResult || props?.selectedData || []).map(item => item.SK?.toString())
      );
      gridApi?.forEachNode(node => {
        const nodeWelderId = node.data.SK?.toString();
        if (selectedWelderSet.has(nodeWelderId)) {
          node.setSelected(true);
        }
      });
    }
    else if (gridApi !== null && props?.wiobj?.WI_Joint_No) {
      const selectedJointSet = new Set(
        props.wiobj.WI_Joint_No.split(',').map(item => item.trim().toLowerCase())
      );
      gridApi?.forEachNode(node => {
        const nodeWiJointNo = node.data.WCS_Joint_No.toString().trim().toLowerCase();
        if (selectedJointSet.has(nodeWiJointNo)) {
          node.setSelected(true);
        }
      });
    }
    setLoading(false);
  };

  const onFirstDataRendered = () => {
    applyDefaultSelection()
  }

  const getKeyField = () => {
    const keyMap = {
      "WPQ": "SK",
      "PED User": "empSalCode",
      "Training Subject and Date": "SK",
      "NPCIL": "WCS_Joint_No",
      "Welder": "SK"
    };
    return keyMap[masterName];
  };

  const applySelectionToVisibleNodes = () => {
    if (selectedData.length > 0 && gridRef?.current?.api) {
      const keyField = getKeyField();
      if (!keyField) return;
      const selectedSet = new Set(selectedData.map(item => item[keyField]?.toString()));
      setTimeout(() => {
        gridRef.current.api.forEachNode((node) => {
          if (selectedSet.has(node?.data[keyField]?.toString())) {
            node.setSelected(true);
          }
        });
      }, 100);
    }
  };

  const getSearchFields = () => {
    const searchMap = {
      "Training Subject and Date": ["wld_trainingSub", "wld_trainingMonth", "wld_fromDate", "wld_toDate", "wld_faculty"],
      "WPQ": ["WPQ_WelderId", "WPQ_WelderName", "WPQ_RecordNo", "wld_WPSType", "WPQ_Inspection", "WPQ_Qualificationcode", "WPQ_PlantLocation", "WPQ_specialNote"],
      "WPQLinkGrid": ["WPQ_WelderId", "WPQ_WelderName", "WPQ_RecordNo", "wld_WPSType", "WPQ_Inspection", "WPQ_Qualificationcode", "WPQ_PlantLocation", "WPQ_specialNote"],
      "Welding Repair- WI Welding Numbers": ["WI_Project_No", "WI_Process", "WI_Joint_No", "WI_Welder_Name", "WI_Welder_Id"],
      "NPCIL": ["WCS_Joint_No"],
      "NPCILGrid": ["WCS_Joint_No"],
      "Welder": ["WI_Welder_Id", "WI_Welder_Name", "WI_ProcessCategory", "WI_plant", "wld_name", "wld_code", "SK"],
      "PED User": ["empSalCode", "empshortName", "empEmailId"]
    };
    return searchMap[masterName] || [];
  };

  const handleGlobalSearch = (text) => {
    const searchText = text.toLowerCase();
    if (searchText) {
      const searchFields = getSearchFields();
      const result = rowData?.filter(item =>
        searchFields.some(field =>
          item[field]?.toString().toLowerCase().includes(searchText)
        )
      );
      setFilteredResult(result);
    } else {
      setFilteredResult(rowData);
    }
    applySelectionToVisibleNodes();
  };

  const resetAllFilter = () => {
    gridRef.current.api.setFilterModel(null);
  };

  function resetFilter(item) {
    let item1 = item.substring(0, item.indexOf(":") - 1);
    let col = gridRef.current.api.getFilterModel();
    for (const key of Object.keys(col)) {
      if (key === feildName(item1)) {
        delete col[key];
      }
    }
    gridRef.current.api.setFilterModel(col);
  }

  const headerMap = {
    "dm_dealercode": "Company Code",
    "dm_dealercompanyname": "Company Name",
    "dm_dealercategory": "Dealer Category",
    "SK": "Role Code",
    "rm_name": "Role Name",
    "WPQ_WelderId": "Welder Id",
    "WPQ_WelderName": "Welder Name",
    "WCS_Joint_No": "Joint Number",
    "WPQ_RecordNo": "WPQ No",
    "wld_WPSType": "Joint Type",
    "WPQ_Inspection": "Inspection agency",
    "WPQ_Qualificationcode": "Qualification Code",
    "WPQ_PlantLocation": "Plant Location",
    "WPQ_specialNote": "Special Notes"
  };

  const fieldMap = {
    "Role Code": "SK",
    "Role Name": "rm_name",
    "Welder Id": "WPQ_WelderId",
    "Joint Number": "WCS_Joint_No",
    "Welder Name": "WPQ_WelderName"
  };

  const headerName = (field) => headerMap[field] || "No match found";
  const feildName = (header) => fieldMap[header] || "No match found";

  const onFilterChanged = (param) => {
    let a = document.getElementById("filterDisplayPop");
    setFilteredCol([]);
    let col = param.api.getFilterModel();
    if (Object.keys(col).length === 0) {
      a.classList.add("d-none");
    } else {
      a.classList.remove("d-none");
      for (const key of Object.keys(col)) {
        let filter;
        if (col[key].condition1) {
          filter =
            headerName(key) +
            " : " +
            col[key].condition1.filter +
            ", " +
            col[key].condition2.filter;
        } else {
          filter = headerName(key) + " : " + col[key].filter;
        }
        setFilteredCol((prev) => {
          return [...prev, filter];
        });
      }
    }
  };

  return (
    <Modal {...props} size="lg" backdrop="static">
      {loading && (
        <div className="loader-overlay">
          <GridLoader size={10} className="pageloader" />
        </div>
      )}
      <Modal.Header closeButton>
        <Modal.Title>{props.masterName.split(":")[0]} </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="global-search-container">
            <GolbalSearch filterFunc={handleGlobalSearch}
              searchplaceholdertext={"Search for Code, Name, ID, etc"}
            />
          </div>
          <div className="d-none mt-2 d-flex" id="filterDisplayPop" style={{ gap: "10px" }}>
            {filteredCol?.map((item) => {
              return (
                <div key={item} className="filter-col pr-0 me-2 d-flex">
                  <div>
                    <span className="ps-2 btn-text">{item}</span>
                  </div>
                  <div onClick={() => resetFilter(item)}>
                    <BsX size={32} />
                  </div>
                </div>
              );
            })}
            <Button variant="outline-primary" className="ms-2 lh-1 clear-all-btn" onClick={resetAllFilter}>
              Clear All
            </Button>
          </div>
          <div className="ag-theme-material d-none d-md-block d-lg-block" style={{ height: 350, width: "100%" }}>
            <AgGridReact
              ref={gridRef}
              onRowSelected={onRowSelected}
              rowData={filteredResult}
              columnDefs={columnDefs}
              rowSelection={"multiple"}
              defaultColDef={defaultColDef}
              onGridReady={onGridReady}
              headerHeight={50}
              rowHeight={50}
              pagination={true}
              paginationPageSize={5}
              onFilterChanged={onFilterChanged}
              onFirstDataRendered={onFirstDataRendered}
              rowMultiSelectWithClick={true}
              domLayout={"autoHeight"}
            ></AgGridReact>
          </div>
        </div>
      </Modal.Body>
      {alertMessage && (
        <Alert className="alertBox" variant="warning">
          {alertMessage}
        </Alert>
      )}
      <Modal.Footer className="justify-content-center justify-content-sm-start">
        {welderid?.length > 0 ? "" :
          <>
            <Button
              size="sm"
              style={{ position: "relative", left: "90%" }}
              className="float-start me-2 d-none d-md-block d-lg-block btn-primary"
              onClick={props?.wiobj ? () => assignDataByType('wpq') : () => assignDataByType()}
            >
              Assign
            </Button>
            <Button size="sm" className="float-start me-2 d-md-none d-lg-none" onClick={() => assignDataByType('custom')}>
              Assign
            </Button>
            <Button style={{ position: "relative", right: "6%" }} size="sm"
              className="float-start me-2" variant="outline-primary" onClick={resetData}>
              Reset
            </Button>
          </>
        }
      </Modal.Footer>
    </Modal>
  );
};

export default MultiValuePopUp;